import { IStackTokens, IStyle, memoizeFunction } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/style-utilities';
import { useScreen } from 'common/hooks/useScreen';
import { AppFontStyles } from 'common/theme/AppFontStyles';
import { IAppTheme, useAppTheme } from 'common/theme/AppTheme';

import { TagState } from './Tag.types';

const getStyles = memoizeFunction(
  (
    theme: IAppTheme,
    isMobileScreen: boolean,
    variant: keyof AppFontStyles,
    textColor: string | undefined,
    bgColor: string | undefined,
    borderColor: string | undefined,
    subtle?: boolean
  ) => {
    return mergeStyleSets({
      root: {
        padding: isMobileScreen ? '4px 8px' : '2px 8px',
        borderRadius: 4,
        background: subtle ? 'transparent' : bgColor,
        border: borderColor && borderColor !== 'transparent' ? `1px solid ${borderColor}` : undefined,
      } as IStyle,
      text: {
        color: textColor,
        ...theme?.appFonts?.[variant],
      } as IStyle,
    });
  }
);

export const useTagStyles = (state?: TagState, subtle?: boolean, variant: keyof AppFontStyles = 'Caption1') => {
  const theme = useAppTheme();
  const { isMobileScreen } = useScreen();
  let bgColor: string | undefined;
  let textColor: string | undefined;
  let iconColor: string | undefined;
  let borderColor: string | undefined;

  switch (state) {
    case 'Green':
      bgColor = theme.appColors?.greenTagBackground;
      textColor = theme.palette.themeDark;
      iconColor = theme.palette.themeDark;
      borderColor = theme.appColors?.greenTagBorder;
      break;
    case 'Yellow':
      bgColor = theme.appColors?.yellowTagBackground;
      textColor = theme.appColors?.lightHeadlineText;
      iconColor = theme.palette.themeDark;
      break;
    case 'Red':
      bgColor = theme.appColors?.redTagBackground;
      textColor = theme.appColors?.redTagText;
      iconColor = theme.appColors?.redTagText;
      borderColor = theme.appColors?.redTagBorder;
      break;
    case 'Grey':
      bgColor = theme.appColors?.gray74ToAnchorTint20;
      textColor = theme.appColors?.lightHeadlineText;
      break;
    default:
      bgColor = theme.appColors?.defaultTagBackground;
      textColor = theme.appColors?.lightHeadlineText;
      break;
  }
  return { classNames: getStyles(theme, isMobileScreen, variant, textColor, bgColor, borderColor, subtle), iconColor };
};

export const stackTokens: IStackTokens = {
  childrenGap: 4,
};
